import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WArticleListingPageHeaderCCD: IClientComponentDefinition = {
  name: 'WArticleListingPageHeader',
  load: () => import(/* webpackChunkName: 'WArticleListingPageHeader' */ './index'),
}
